import { render, staticRenderFns } from "./PublishMenu.vue?vue&type=template&id=36ff579e&"
import script from "./PublishMenu.vue?vue&type=script&lang=js&"
export * from "./PublishMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PublishMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/PublishMenu.vue
// module id = 2314
// module chunks = 1